import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { ToastrService } from "ngx-toastr";
import { OnboardEmployeeDetails } from "../../shared/models/OnboardEmployeeDetails";
import { FileUploadVerService } from "../../shared/service/fileUploadVer.service";
import { ComponentIdentificationService } from "../../shared/service/component-identification.service";
import { isNullOrUndefined, isUndefined } from "util";
import { OnboardEmpAddressDetail } from "../../shared/models/OnboardEmpAddressDetail";
import { ProfileImageUpload } from "../../shared/models/ProfileImageUpload";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import * as _moment from "moment";
import { DatePipe } from "@angular/common";
import { HREmployeeDetails } from "../../shared/models/hremployeecommunicationdetails.model";
import { EmployeeService } from "../../shared/service/employee.service";
import { HrEmpAdddressDetails } from "../../shared/models/HrEmpAddressDetails";
import { File_Types, Profile_File_Types, Resume_File_Types } from "../../shared/UploadFileTypes";
import { ExampleHeader } from "../../shared/pipes/date.directive";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Observable } from "rxjs";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-basic-emp-details",
  templateUrl: "./basic-emp-details.component.html",
  styleUrls: ["./basic-emp-details.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class BasicEmpDetailsComponent implements OnInit {
  profileImageUpload: any;
  MAX_SIZE: number = 1048576;
  EmpDetform: FormGroup;
  @Input() Status: number;
  @Input() Slug: string;
  @Input() checkBoxDisable: string;
  empId: any;
  @Output("EmpId") EmpId = new EventEmitter();
  @Output("employeeDtlsOutput") employeeDtlsOutput = new EventEmitter();
  @ViewChild("avatarImg", { static: true })
  avatarImgElement: ElementRef;
  profileImageUrl: ElementRef | any;
  error: any;
  employeeDetails: any;
  parentComponentName: string;
  AddressSame: boolean = false;
  @Input() empCode: number;
  todayDate: Date;
  EmpAddform: FormGroup;
  isLoader: boolean = true;
  maxDate: Date;
  doj: Date;
  exampleHeader = ExampleHeader;
  isAdharPresnt: boolean = false;
  @Input() photo: string | SafeUrl;
  @Output() photoUpdated = new EventEmitter<string | SafeUrl>();
  showAddPhotoOverlay = false;
  image: string | SafeUrl;
  FileAsBase64: string | ArrayBuffer;
  imageInfos?: Observable<any>;
  isInvalidUrl: boolean = false;
  EmployeeList: any;
  private linkedInUrlPattern = /^(https?:\/\/)?(www\.)?(linkedin\.com\/.*)$/;


  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event: any) => {
        // called once readAsDataURL is completed
        this.employeeDetails.ProfileFilePath = event.target.result;
      };
      const files: FileList = event.target.files;
      //reader.readAsDataURL(files.item(0));
      if (files && files.length > 0) {
        if (!this.validFileType(files[0])) {
          this.toastr.warning(
            "File name " + files[0].name + ": Not a valid file type."
          );
        }
        // Don't allow file sizes over 1MB
        if (files[0].size < this.MAX_SIZE) {
          this.employeeDetails.Profilefile =
            this.file_Svc.readAndUploadProfilePic(files);
        } else {
          this.toastr.warning(
            " File: " +
            files[0].name +
            " exceeds 1MB hence it cannot be uploaded."
          );
        }
      }
    }
  }

  constructor(
    public _service: OnboardingService,
    public toastr: ToastrService,
    public file_Svc: FileUploadVerService,
    private changeCom_svc: ComponentIdentificationService,
    private emp_Svc: EmployeeService,
    private sanitizer: DomSanitizer,
    private uploadService: FileUploadVerService,
    private cdr: ChangeDetectorRef
  ) { }

  ngDoCheck() {
    if (this.employeeDetails.AadharFilePath) {
      this.isAdharPresnt = false;
      this.EmpDetform.controls["AadharFile"].clearValidators();
      this.EmpDetform.controls["AadharFile"].setErrors(null);
    } else {
      this.EmpDetform.controls["AadharFile"].setValidators([Validators.required]);
    }

    if (this.employeeDetails.PanFilePath) {
      this.EmpDetform.controls["PanFile"].clearValidators();
      this.EmpDetform.controls["PanFile"].setErrors(null);
    }
    else {
      this.EmpDetform.controls["PanFile"].setValidators([Validators.required]);
    }

    if (this.employeeDetails.ResumeDocumentPath) {
      this.EmpDetform.controls["ResumeFile"].clearValidators();
      this.EmpDetform.controls["ResumeFile"].setErrors(null);
    }
    else {
      this.EmpDetform.controls["ResumeFile"].setValidators([Validators.required]);
    }
  }

  ngOnInit() {
    this.profileImageUpload = new ProfileImageUpload();
    this.todayDate = new Date();
    this.changeCom_svc.componentName.subscribe(
      (response) => (this.parentComponentName = response)
    );
    if (this.parentComponentName == "app-hr-employee-details") {
      this.employeeDetails = new HREmployeeDetails();
      if (!isUndefined(this.empCode)) {
        this.GetHrEmpolyeeDetails();
      }
    } else {
      this.employeeDetails = new OnboardEmployeeDetails();
      this.getEmployeebySlugStatus();
    }
    //this.setDOB();
    this.EmpDetform = new FormGroup({
      Title: new FormControl(),
      FirstName: new FormControl(),
      LastName: new FormControl(),
      MiddleName: new FormControl(),
      NamePerRecords: new FormControl(),
      DOB: new FormControl(),
      LinkedInID: new FormControl(),
      CelebratedDOB: new FormControl(),
      Gender: new FormControl(),
      MobileNumber: new FormControl(),
      BloodGroup: new FormControl(),
      WhatsappNo: new FormControl(),
      //  Email: new FormControl(),
      PAN: new FormControl(),
      Aadhar: new FormControl(),
      PanFile: new FormControl(),
      AadharFile: new FormControl(""),
      avatar: new FormControl(""),
      ResumeFile: new FormControl()
    });

    this.FormInitialization();
    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
  }

  getFileName(type) {
    if (type == 'aadhar')
      return this.employeeDetails.NamePerRecords +"_Aadhar";
    else
      return this.employeeDetails.NamePerRecords + "_Pan";
  }

  handleFile(event, n) {
    if (event.target.files == undefined) {
      if (n == 0) {
        this.employeeDetails.Aadharfile = null;
      } else if (n == 1) {
        this.employeeDetails.Panfile = null;
      }
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      // Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        if (n == 0) {
          this.employeeDetails.Aadharfile =
            this.file_Svc.readAndUploadFile(files);
          this.employeeDetails.AadharFilePath = null;
        } else if (n == 1) {
          this.employeeDetails.Panfile = this.file_Svc.readAndUploadFile(files);
          this.employeeDetails.PanFilePath = null;
        }
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
        // this.EmpDetform.controls.AadharFile.setValue("");
      }
    }
  }

  handleResumeFile(event) {
    if (event.target.files == undefined) {
      this.employeeDetails.ResumeFile = null;
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFile(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      // Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        this.employeeDetails.ResumeFile = this.file_Svc.readAndUploadFile(files);
        this.employeeDetails.ResumeDocumentPath = null;
      }
      else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
  }

  setDocName() {
    return this.employeeDetails.NamePerRecords + "_Resume";
  }

  validFile(file: File) {
    let types = Resume_File_Types;
    return types.includes(file.type);
  }

  validFileType(file) {
    let types = File_Types;
    return types.includes(file.type);
  }

  openFileInput(fileInput) {
    fileInput.click();
    this.showAddPhotoOverlay = false;
  }

  getOfficeViewerUrl(docUrl: string): string {
    return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(docUrl)}`;
  }

  addPhoto(event) {
    const fileReader = new FileReader();
    if (event.target.files == undefined) {
      this.profileImageUpload = null;
    }

    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileTypeProfile(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      //  Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        if (event.target.files && event.target.files[0]) {
          fileReader.readAsDataURL(event.target.files[0]); // read file as data url
          fileReader.onload = (event: any) => {
            this.profileImageUrl = event.target.result;
            this.FileAsBase64 = fileReader.result.toString();
            this.profileImageUpload = this.file_Svc
              .profileUpload(
                files,
                this.profileImageUrl,
                this.employeeDetails.EmpId
              )
              .subscribe((data: any) => {
                this.uploadService
                  .getUserProfileDetails(this.employeeDetails.EmpId)
                  .subscribe((data: any) => {
                    this.toastr.info("Profile image uploaded successfully");
                    this.imageInfos = data && data.ProfileFilePath;
                    this.photo = data && data.ProfileFilePath;
                    this.profileImageUrl = data && data.ProfileFilePath;
                    this.photoUpdated.emit(this.photo);
                  });
              });
          };
        }
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        //  Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
    // fileReader.readAsDataURL(event.target.files[0]);
  }

  validFileTypeProfile(file) {
    let types = Profile_File_Types;
    return types.includes(file.type);
  }

  removePhoto() {
    this.profileImageUrl = '';
    this.photo = '';
    this.photoUpdated.emit(this.photo);
    this.uploadService.deleteEmployeeProfile(this.employeeDetails.EmpId).subscribe(
      (response: any) => {
        if (response.success) {
          this.profileImageUrl = '';
          this.photo = '';
          this.photoUpdated.emit(this.photo);
          this.cdr.detectChanges();
        } else {
          console.error('Failed to delete photo');
        }
      },
      (error) => {
        console.error('Error occurred while deleting photo:', error);
      }
    );
  }

  FormInitialization() {
    this.EmpAddform = new FormGroup({
      City: new FormControl(),
      District: new FormControl(),
      State: new FormControl(),
      Country: new FormControl(),
      PinCode: new FormControl(),
      HouseNo: new FormControl(),
      StreetName: new FormControl(),
      PCity: new FormControl(),
      PDistrict: new FormControl(),
      PState: new FormControl(),
      PCountry: new FormControl(),
      PPinCode: new FormControl(),
      PHouseNo: new FormControl(),
      PStreetName: new FormControl(),
      AddressCB: new FormControl(),
    });
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.EmpDetform.controls;
  }
  get a() {
    return this.EmpAddform.controls;
  }


  getEmployeebySlugStatus() {
    this._service.getEmployeebySlugStatus(this.Slug, this.Status).subscribe(
      (data: any) => {
        if (data != null) {
          this.employeeDetails = data;
          if (isNullOrUndefined(this.employeeDetails.TemporaryAddress)) {
            this.employeeDetails.TemporaryAddress =
              new OnboardEmpAddressDetail();
            this.employeeDetails.TemporaryAddress.IsAddressSame = false;
          }

          if (this.employeeDetails.TemporaryAddress.IsAddressSame) {
            this.AddressSame = true;
            this.disablePermanentAddressFields();
          } else {
            this.enablePermanentAddressFields();
          }

          if (isNullOrUndefined(this.employeeDetails.PermanentAddress)) {
            this.employeeDetails.PermanentAddress =
              new OnboardEmpAddressDetail();
          }

          this.EmpId.emit(this.employeeDetails.EmpId);
          this.employeeDtlsOutput.emit(this.employeeDetails);
          this.uploadService
            .getUserProfileDetails(this.employeeDetails.EmpId)
            .subscribe((data: any) => {
              this.imageInfos = data && data.ProfileFilePath;
              this.photo = data && data.ProfileFilePath;
              this.profileImageUrl = data && data.ProfileFilePath;
              this.photoUpdated.emit(this.photo);
            });
          this.setDOB();
        }
      },
      (error) => (this.error = error)
    );
  }

  onlyAlpha(event: any) {
    const pattern = /[a-zA-Z]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  GetHrEmpolyeeDetails() {
    this.emp_Svc.getEmployeeDetails(this.empCode).subscribe(
      (data: any) => {
        this.employeeDetails = data;

        if (isNullOrUndefined(this.employeeDetails.TemporaryAddress)) {
          this.employeeDetails.TemporaryAddress = new HrEmpAdddressDetails();
          this.employeeDetails.TemporaryAddress.IsAddressSame = false;
        }
        //else {

        if (this.employeeDetails.TemporaryAddress.IsAddressSame) {
          this.AddressSame = true;
          this.disablePermanentAddressFields();
        } else {
          this.enablePermanentAddressFields();
        }
        //}
        if (isNullOrUndefined(this.employeeDetails.PermanentAddress)) {
          this.employeeDetails.PermanentAddress = new HrEmpAdddressDetails();
        }

        this.employeeDtlsOutput.emit(this.employeeDetails);
        this.setDOB();
      },
      (error) => (this.error = error)
    );
  }
  copyTempAddr(event: any) {
    if (event.checked && this.employeeDetails.TemporaryAddress != null) {
      this.employeeDetails.TemporaryAddress.IsAddressSame = true;
      this.disablePermanentAddressFields();
      this.employeeDetails.PermanentAddress =
        this.employeeDetails.TemporaryAddress;
    } else {
      this.employeeDetails.TemporaryAddress.IsAddressSame = false;
      this.enablePermanentAddressFields();
      this.employeeDetails.PermanentAddress = new OnboardEmpAddressDetail();
    }
  }
  disablePermanentAddressFields() {
    this.EmpAddform.get("PCity").disable();
    this.EmpAddform.get("PDistrict").disable();
    this.EmpAddform.get("PState").disable();
    this.EmpAddform.get("PCountry").disable();
    this.EmpAddform.get("PPinCode").disable();
    this.EmpAddform.get("PHouseNo").disable();
    this.EmpAddform.get("PStreetName").disable();
  }
  enablePermanentAddressFields() {
    this.EmpAddform.get("PCity").enable();
    this.EmpAddform.get("PDistrict").enable();
    this.EmpAddform.get("PState").enable();
    this.EmpAddform.get("PCountry").enable();
    this.EmpAddform.get("PPinCode").enable();
    this.EmpAddform.get("PHouseNo").enable();
    this.EmpAddform.get("PStreetName").enable();
  }

  setDOB() {
    this._service
      .getEmployeebyId(this.employeeDetails.EmpId)
      .subscribe((data: any) => {
        if (data && data.DOJ) {
          this.doj = data.DOJ;
          var dob = new Date(this.doj);
          dob.setFullYear(dob.getFullYear() - 18);
          this.maxDate = dob;
        }
      });
  }

  checkURL() {
    this.isInvalidUrl = this.employeeDetails.LinkedInID != null && this.employeeDetails.LinkedInID.trim() != '' ? !(this.linkedInUrlPattern.test(this.employeeDetails.LinkedInID)) : false;
  }
}
